import { parseSpaConfig } from '@ori-appshell/config';

const GRAPHQL_STRING = 'graphql';

export const getAppConfiguration = (config: string) => {
  const configValues = parseSpaConfig<{
    ssoAdLoginUrl: string;
    isCumulusMarket: boolean;
    mobileOfficeApiUrl: string;
    staticApiUrl: string;
    shouldDisplayNotificationIcon: boolean;
    globalApiUrl: string;
    identityUrl: string;
  }>(config, [
    'globalApiUrl',
    'identityUrl',
    'staticApiUrl',
    'mobileOfficeApiUrl',
    'ssoAdLoginUrl',
    'isCumulusMarket',
    'shouldDisplayNotificationIcon',
  ]);

  const graphQlUrl = configValues.graphqlUrl;

  if (!graphQlUrl.endsWith(GRAPHQL_STRING)) {
    configValues.graphqlUrl = new URL(GRAPHQL_STRING, graphQlUrl).href;
  }

  return configValues;
};
